// covered-by: frontends/carrie/src/routes/ask-puntt/hooks/__tests__/useAskPunttDesktopNotifications.test.ts
import { useAskPunttDesktopNotifications } from "../routes/ask-puntt/hooks/useAskPunttDesktopNotifications";

/** Side-effect hook mount for Ask Puntt desktop notifications. */
export function AskPunttDesktopNotificationsWatcher() {
  useAskPunttDesktopNotifications();
  return null;
}
